import { render, staticRenderFns } from "./TableChicksMissing.vue?vue&type=template&id=490ca9b8&scoped=true"
import script from "./TableChicksMissing.vue?vue&type=script&lang=js"
export * from "./TableChicksMissing.vue?vue&type=script&lang=js"
import style0 from "./TableChicksMissing.vue?vue&type=style&index=0&id=490ca9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ca9b8",
  null
  
)

export default component.exports